<template>
    <div>
        <el-dialog :close-on-click-modal="false" class="edit-contract" title="修改合同" v-dialogDrag :visible.sync="visible"
            :before-close="onClose" width="800px">
            <el-form label-position="left" size="mini" :model="form" :rules="rules" ref="form" label-width="110px">
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="法务合同号" prop="legalContractCode">
                            <SrmAdvance :params="contractConfig" :formData="contractFormData"
                                :mValue="form.legalContractCode"
                                :customClass="'storage-delegate-contract-advance-dialog'"
                                @getAdvanceValue="getAdvanceValue($event, 'legalContractCode')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item prop="delegateType" label="委派函">
                    <el-radio-group :disabled="isSupplier" @change="getApprover" v-model="form.delegateType">
                        <el-radio :label="DELEGATE_TYPES.ONLINE">线上</el-radio>
                        <el-radio :label="DELEGATE_TYPES.OFFLINE">线下</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="选择签署人" prop="signerName"
                            v-if="form.delegateType === DELEGATE_TYPES.ONLINE">
                            <SrmAdvance :params="stamperParams" :formData="{ supplierCode: form.supplierCode }"
                                :mValue="form.signerName" :icon="'el-icon-s-custom'" :disabled="!form.supplierCode"
                                @getAdvanceValue="getAdvanceValue($event, 'signerName')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="delegate-wrapper" v-if="form.delegateType === DELEGATE_TYPES.OFFLINE">
                    <el-form-item label="纸质委派函上传" prop="warehouseDelegateFlieList">
                        <Upload uploadDisplayType="button" text="选择文件" :fileTypeReg="/\.(jpg|jpeg|png|pdf)$/"
                            accept=".png,.jpg,.jpeg,.pdf"
                            :disabled="form.warehouseDelegateFlieList.length >= 5 || isSupplier"
                            @uploadSuccess="handleUploadSuccess" />
                        <el-button type="text" :loading="tempLoading" :disabled="isSupplier"
                            @click="handleTemp">下载模板</el-button>
                    </el-form-item>
                    <AttachmentTable :tableData="form.warehouseDelegateFlieList" @preview="handlePreview"
                        @reupload="handleReupload" @delete="handleDelete" />
                    <el-row :gutter="16" class="delegate-time-row">
                        <el-col :span="8">
                            <el-tooltip class="delegate-start-time-tooltip" effect="dark" content="默认赋值提交时间"
                                placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                            <el-form-item label="委派开始时间" prop="delegateStartTime" class="delegateStartTime">
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.delegateStartTime" disabled
                                    type="date" placeholder="请输入日期" style="width: 100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-tooltip class="delegate-end-time-tooltip" effect="dark" content="默认赋值合同终止时间"
                                placement="top">
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                            <el-form-item label="委派结束时间" prop="delegateEndTime" class="delegateEndTime">
                                <el-date-picker value-format="yyyy-MM-dd" v-model="form.delegateEndTime" disabled
                                    type="date" placeholder="请输入日期" style="width: 100%"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="主工作逻辑仓" prop="mainLogicalWarehouseName">
                            <SrmAdvance
                                :params="logicalWarehouseParams"
                                :mValue="form.mainLogicalWarehouseName"
                                @getAdvanceValue="getAdvanceValue($event, 'mainLogicalWarehouseName')" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- <el-form-item label="审批人" prop="approverList">
                    <div tabindex="0" @keyup.backspace="handleBackSpace" v-clickoutside="handleClickOutside" :class="['approver-wrap',isFocus && 'focus']" @click="focusApprover">
                        <el-tag
                            @close="delApprover(idx)"
                            class="approver-tag"
                            v-for="(tag, idx) in form.approverList"
                            :key="tag.approvalCode"
                            :effect="isFocus ?'dark' : 'light'"
                            :closable="form.approverList.length > 1"
                            disable-transitions
                            :type="isFocus ? '' : 'info'">
                            {{tag.approvalName}}
                        </el-tag>
                    </div>
                    <div class="approver-tips">可以删减人员，不可以更换，最少保留一人，最多20人</div>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :loading="btnLoading" @click="submit('save')">保存</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submit('approve')">提交审批</el-button>
            </span>
        </el-dialog>


        <Preview v-if='attachmentShow' :attachmentList="attachmentList" :attachmentShow.sync='attachmentShow'
            :rowData='rowData'>
        </Preview>
    </div>
</template>
<script>
import Clickoutside from 'element-ui/src/utils/clickoutside'
import dayjs from 'dayjs'
import Preview from '../../../components/viewAttachment.vue';
import AttachmentTable from './AttachmentTable.vue'
import SrmAdvance from '../../../components/srmAdvance/index.vue'
import Upload from '../../../components/upload/Index.vue'
import { dictWithUrl } from '@/components/lots/api'
import {
    queryApprove,
    downloadTemplate,
    batchChangeContractSave,
    batchChangeContractSubmit,
} from '../../../api/warehouseResourceManagement/warehouseDelegationLetter.js'
import { DELEGATE_TYPES, contractConfig, logicalWarehouseParams } from './constant.js'
import { stamperParams } from '../../register/manage/keyData/tabs/driver/newUploadVersion/config.js'
const INIT_FORM = {
    contractCode: '',
    legalContractCode: '',
    siteCode: '',
    delegateType: '1',
    approverList: [],
    supplierCode: '',
    warehouseDelegateFlieList: [],
    delegateStartTime: '',
    delegateEndTime: '',
    signerName: '',
    signerPhone: '',
    mainLogicalWarehouseName: '',
    mainLogicalWarehouseCode: '',
}
export default {
    directives: { Clickoutside },
    components: { SrmAdvance, Upload, AttachmentTable, Preview },
    data() {
        return {
            attachmentShow: false,
            attachmentList: [],
            rowData: {},
            tempLoading: false,
            btnLoading: false,
            DELEGATE_TYPES,
            form: JSON.parse(JSON.stringify(INIT_FORM)),
            rules: {
                legalContractCode: [
                    { required: true, message: '请选择法务合同号', trigger: ['change', 'blur'] }
                ],
                delegateType: [
                    { required: true, message: '请选择委派函类型', trigger: ['change', 'blur'] }
                ],
                signerName: [
                    { required: true, message: '请选择签署人', trigger: ['change', 'blur'] }
                ],
                signerPhone: [{ required: true, message: '请输入签署人手机号', trigger: ['change'] }],
                delegateEndTime: [{ required: true, message: '请选择委派结束时间', trigger: ['change'] }],
                warehouseDelegateFlieList: [{ required: true, message: '请上传纸质委派函', trigger: ['change'] }],
                mainLogicalWarehouseName: [{ required: true, message: '请选择主工作逻辑仓', trigger: ['change'] }],
                approverList: [
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 20) {
                                callback(new Error('审批人最多20人'));
                            } else {
                                callback();
                            }
                        }, trigger: ['blur', 'change']
                    }],
            },
            stamperParams: {
                ...stamperParams,
                value: 'signerName',
                advanceCascade: 'supplierCode',
                cbParams: ['stamperCode#signerCode', 'stamperName#signerName', 'stamperMobile#signerPhone']
            },
            logicalWarehouseParams,
            visible: false,
            warehouseDelegateNoList: '',
            isFocus: false,
        }
    },
    computed: {
        contractConfig() {
            const advanceConfig = JSON.parse(JSON.stringify(contractConfig))
            advanceConfig.advanceUrl = this.isSupplier ? '/contract/supplierWarehouseContractPage' : '/contract/warehouseContractPage'
            return advanceConfig
        },
        contractFormData() {
            return this.isSupplier ? { supplierCode: this.$store.state.supplier.supplierCode } : {}
        },
        isSupplier() {
            return !!this.$store.state.supplier
        },
    },
    methods: {
        handleClickOutside(){
            this.isFocus = false  
        },
        focusApprover(){
            this.isFocus = true
        },
        handleBackSpace(){
            if(this.isFocus && this.form.approverList.length > 1){
                this.delApprover(this.form.approverList.length - 1)
            }
        },
        handleDelete(index) {
            this.form.warehouseDelegateFlieList.splice(index, 1)
        },
        handleReupload(result, index) {
            this.form.warehouseDelegateFlieList[index].fileId = result.data.data.id
            this.form.warehouseDelegateFlieList[index].fileUrl = result.data.data.downUrl
            this.form.warehouseDelegateFlieList[index].fileName = result.data.data.localFileName
            this.form.warehouseDelegateFlieList[index].uploadTime = dayjs(result.data.timestamp).format('YYYY-MM-DD HH:mm:ss')
            this.form.warehouseDelegateFlieList.sort((a, b) => dayjs(b.uploadTime).valueOf() - dayjs(a.uploadTime).valueOf())
        },
        handlePreview(downUrl) {
            if (!downUrl) {
                return this.$message.warning('暂无可预览的文件!')
            }
            this.attachmentShow = true
            this.rowData = { downUrl }
        },
        handleTemp() {
            this.tempLoading = true
            downloadTemplate().then(res => {
                if (res && +res.code === 0) {
                    const a = document.createElement('a')
                    a.href = res.data.downUrl
                    a.download = res.data.localFileName
                    a.click()
                    this.$message.success('下载成功')
                }
            }).finally(() => { this.tempLoading = false })
        },
        handleUploadSuccess(result) {
            this.form.warehouseDelegateFlieList.unshift({
                id: null,
                warehouseDelegateCode: null,
                fileId: result.data.data.id,
                fileUrl: result.data.data.downUrl,
                fileName: result.data.data.localFileName,
                uploadTime: dayjs(result.data.timestamp).format('YYYY-MM-DD HH:mm:ss')
            })
        },
        delApprover(idx) {
            this.form.approverList.splice(idx, 1)
            this.$nextTick(() => {
                this.$refs['form'].validateField('approverList')
            })
        },
        getApprover() {
            if (this.form.delegateType && this.form.legalContractCode && this.form.siteCode) {
                queryApprove({ delegateType: this.form.delegateType, legalContractCode: this.form.legalContractCode, siteCode: this.form.siteCode }).then(res => {
                    if (res && +res.code === 0) {
                        this.form.approverList = res.data || []
                    } else {
                        this.form.approverList = []
                    }
                    this.$nextTick(() => {
                        this.$refs['form'].validateField('approverList')
                    })
                })
            }
        },
        getAdvanceValue(val, prop) {
            if (prop === 'legalContractCode') {
                this.form.legalContractCode = val.legalContractCode
                this.form.contractCode = val.contractCode
                this.form.contractName = val.contractName
                this.form.physicalWarehouseName = val.physicalWarehouseName
                this.form.delegateEndTime = val.expirationDate ? dayjs(val.expirationDate).format('YYYY-MM-DD HH:mm:ss') : null
                this.form.supplierCode = val.supplierCode
                this.form.supplierName = val.supplierName
                this.form.signerCode = null
                this.form.signerName = null
                this.form.signerPhone = null
                this.form.siteCode = val.siteCode
                this.getApprover()
            } else if (prop === 'signerName') {
                this.form.signerCode = val.signerCode
                this.form.signerName = val.signerName
                this.form.signerPhone = val.signerPhone
            } else if (prop === 'mainLogicalWarehouseName') {
                this.form.mainLogicalWarehouseName = val.mainLogicalWarehouseName
                this.form.mainLogicalWarehouseCode = val.mainLogicalWarehouseCode
            }
        },
        init(warehouseDelegateNoList) {
            this.warehouseDelegateNoList = warehouseDelegateNoList
            this.visible = true
        },
        onClose() {
            this.visible = false
            this.form = JSON.parse(JSON.stringify(INIT_FORM))
            this.$nextTick(() => {
                this.$refs.form.clearValidate()
            })
        },
        submit(type) {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let params = {
                        warehouseDelegateNoList: this.warehouseDelegateNoList,
                        contractCode: this.form.contractCode,
                        legalContractCode: this.form.legalContractCode,
                        delegateType: this.form.delegateType,
                        approverList: this.form.approverList,
                        mainLogicalWarehouseCode: this.form.mainLogicalWarehouseCode,
                        mainLogicalWarehouseName: this.form.mainLogicalWarehouseName,
                    }
                    if (this.form.delegateType === DELEGATE_TYPES.ONLINE) {
                        params = {
                            ...params,
                            signerCode: this.form.signerCode,
                            signerName: this.form.signerName,
                            signerPhone: this.form.signerPhone,
                        }
                    }else{
                        params = {
                            ...params,
                            warehouseDelegateFlieList: this.form.warehouseDelegateFlieList
                        }
                    }
                    this.btnLoading = true
                    const api = type === 'save' ? batchChangeContractSave : batchChangeContractSubmit
                    api(params).then(res => {
                        if (res && res.code === '0') {
                            this.$message.success('操作成功')
                            this.$emit('refresh')
                            this.onClose()
                        }
                    }).finally(() => {
                        this.btnLoading = false
                    })
                }
            });
        },
    },
}
</script>
<style scoped lang="less">
.edit-contract {
    .approver-wrap {
        border: 1px solid rgb(206, 206, 206);
        padding: 10px;
        border-radius: 4px;
        min-height: 50px;
        box-sizing: border-box;
        outline: none;
        &.focus{
            border-color: #00bcbf;
        }
    }

    .approver-tag {
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .approver-tips {
        color: orange;
        font-size: 12px;
    }

    .delegate-wrapper {
        padding: 18px 15px 0;
        margin-bottom: 17px;
        border: 1px solid #ccc;
    }

    .register-upload {
        display: inline-block;
        margin-right: 10px;
    }

    .delegate-time-row .el-col {
        position: relative;
    }

    .delegate-start-time-tooltip {
        position: absolute;
        top: 8px;
        left: 86px;
    }

    .delegate-end-time-tooltip {
        position: absolute;
        top: 8px;
        left: 93px;
    }

    .el-card {
        margin: 10px 0 22px;
    }

    .el-card__header {
        padding: 0 15px;
        height: 40px;
        line-height: 40px;
    }

    .ocr-upload-container {
        height: 170px;
    }

    .el-upload-dragger {
        width: 100%;
        height: 100%;
    }

    .el-date-editor.el-input {
        width: 100%;
    }
}
</style>
